// process.env.NODE_ENV === 'production' ? console.log('Production mode!') : require('__page/index.html');
const mc = require('__libs/ModuleConstructor.js');
if(window.innerWidth > 639) {
	mc.runVue(['Slider', 'Navigation', 'selectList']);
} else {
	const components = document.querySelectorAll('[is]');
	let lazyBackgroundObserver = new IntersectionObserver(function(entries, observer) {
		$(entries).each(function(index, entry) {
			// console.log(entry);
			if(window.Vue) lazyBackgroundObserver = null;
			if (entry.isIntersecting) {
				if(entry.target.getAttribute('is') === 'Navigation') {
					$(entry.target).on('click', function (e) {
						e.currentTarget.classList.add('open');
						mc.runVue(['Slider', 'Navigation', 'selectList']);
					}.bind(this));
					return;
				};
				mc.runVue(['Slider', 'Navigation', 'selectList']);
			}
		});
	});
	$(Array.from(components)).each(function(i, lazyBackground) {
		lazyBackgroundObserver.observe(lazyBackground);
	});
}
mc.runComponents(['rating']);
mc.runFooter();



// WEBPACK FOOTER //
// ./entries/news-detail.js